/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { axiosInstance } from '../axiosInstance'
export const getAllAccess = param => {
    try {

        return axiosInstance.post(`api/gcadmin/v1/access-record/getAll`, param).then(res => res.data);
    } catch (error) {
        throw error;
    }
} 